"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useQueryParam;
var _react = require("react");
function useQueryParam(paramName, defaultValue = '') {
  let currentValue = defaultValue;
  if (typeof window !== 'undefined' && typeof window.location !== 'undefined') {
    const url = new URL(window.location);
    currentValue = url.searchParams.get(paramName);
  }
  const [value, setValue] = (0, _react.useState)(currentValue);
  (0, _react.useEffect)(() => {
    const url = new URL(window.location);
    if (value) {
      url.searchParams.set(paramName, value);
    } else {
      url.searchParams.delete(paramName);
    }
    if (window.location.href !== url.href) {
      window.history.pushState({}, '', url);
    }
  }, [value]);
  return [value, setValue];
}